<template>
  <CarouselBase :carousel-list="carouselList">
    <template #card="{ item }">
      <CardPartners
        :title="item.name"
        :description="item.description"
        :image-url="item.imageUrl"
        :focused-solutions="item.focusedSolutions"
      />
    </template>
  </CarouselBase>
</template>

<script setup lang="ts">
  import type { IPartnersCarousel } from '@/components/Shared/Carousel/types';

  interface IProps {
    carouselList: IPartnersCarousel[];
  }

  withDefaults(defineProps<IProps>(), {
    carouselList: () => [],
  });
</script>
